<template>
  <v-autocomplete
      v-model="lgota"
      :items="lgotas"
      :loading="isLoading"
      item-text="Id"
      item-value="Id"
      :clearable="false"
      :dense="true"
      :no-filter="true"
      :allow-overflow="false"
      @change="onChange"
      outlined
  >
    <template v-slot:no-data>
      <v-list-item> По данному фильтру нет данных</v-list-item>
    </template>

    <template v-slot:selection="{ item }">
      <v-list-item-content color="success">
        <v-list-item-title>{{ item.Id }}</v-list-item-title>
        <v-list-item-subtitle>{{ item.Name }}</v-list-item-subtitle>
      </v-list-item-content>
    </template>

    <template v-slot:item="{ item }">
      <v-list-item-content>
        <v-list-item-title v-html="item.Id"></v-list-item-title>
        <v-list-item-subtitle v-html="item.Name"></v-list-item-subtitle>
      </v-list-item-content>
    </template>
  </v-autocomplete>
</template>

<script>
import CompanyService from '@/services/company.service'

export default {
  name: "SelectInvoiceItemLgota",
  data() {
    return {
      lgota: null,
      lgotas: [],
      isLoading: false,
      filterTimerId: null
    };
  },
  methods: {
    onChange() {
      this.$emit("input", this.lgota);
      this.$emit("change", this.lgota);
    },
    load() {
      this.isLoading = true
      CompanyService.getLgota()
      .then(response => {
        this.lgotas = response.data
      })
      .finally(() => {
        this.isLoading = false
      })
    },
  },
  created() {
    this.load()
  },
}
</script>

<style scoped>

</style>